import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.js";
import { SettingsProvider } from "./contexts/SettingsContext.js";
import { AuthProvider } from "./contexts/AuthContext.js";
import { QuoteCartProvider } from "./contexts/QuoteCartContext.js";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root element missing in index.html");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <SettingsProvider>
          <QuoteCartProvider>
            <App />
          </QuoteCartProvider>
        </SettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
